import * as React from 'react';
import isEqual from 'react-fast-compare';
import { tryCheckout } from '../../../cart/actions/cart-actions';
import { CartSeat } from '../../../classes/seat';
import { SeatingOptionGroup } from '../../../classes/seating-option';

export interface ICheckoutButtonProps {
    dispatch: any /*Dispatch<any>*/;

    itemId: number;
    showAddMoreButton: boolean;

    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>; //used for non-seat bound seating options
    additionalNotes: string;

    cartCheckoutButton: string;
    cartAddMoreButton: string;
    cartDisabled: boolean;

    //CartItems props
    cartSeats: Array<CartSeat>;
}

class CheckoutButton extends React.Component<ICheckoutButtonProps, null>{
    
    shouldComponentUpdate(nextProps: ICheckoutButtonProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.cartDisabled != nextProps.cartDisabled
            || !isEqual(this.props.cartSeats.map(s => s.selectedPricing.priceTypeId), nextProps.cartSeats.map(s => s.selectedPricing.priceTypeId))
            || !isEqual(this.props.selectedAdditionalOptionGroups, nextProps.selectedAdditionalOptionGroups);
    }

    render() {

        const disableButton = this.props.cartSeats.length === 0 || this.props.cartDisabled;
        return (
            <div className="cart-mini-cta">
                {this.props.showAddMoreButton ?
                    <button className={"cart-mini-cta-btn-primary" + (disableButton ? " disabled" : "")}
                        disabled={disableButton}
                        onClick={this._onAddMoreCheckoutClick.bind(this)}>
                        {this.props.cartAddMoreButton}
                    </button> : null
                }
                <button className={"cart-mini-cta-btn-primary" + (disableButton ? " disabled" : "")}
                    disabled={disableButton}
                    onClick={this._onCheckoutClick.bind(this)}>
                    {this.props.cartCheckoutButton}
                </button>
            </div>
        );
    }

    _onCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, false));
    }

    _onAddMoreCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, true));
    }

}

export default CheckoutButton;